import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import SearchPath from '../../../../components/search-path';

class SearchPathModal extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.close = this.close.bind(this);
    this.updateSearchPath = this.updateSearchPath.bind(this);
  }

  updateSearchPath(paths) {
    this.props.onAdd(paths);
  }

  close() {
    this.props.onClose();
  }

  render() {
    const { open, isAccount } = this.props;

    return (
      <Modal show={open} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Add Field</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <SearchPath
              paths={[]}
              onUpdate={this.updateSearchPath}
              selectedSearchPaths={[]}
              validTypes={['email', 'string']}
              startingNode={isAccount ? 'Account' : 'Opportunity'}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button bsStyle="default" onClick={this.close}>Cancel</Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

SearchPathModal.propTypes = {
  onClose: PropTypes.func,
  onAdd: PropTypes.func,
  open: PropTypes.bool,
  isAccount: PropTypes.bool,
};
SearchPathModal.defaultProps = {
  open: false,
  onClose: () => {},
  onAdd: () => {},
  isAccount: false,
};


export default connect(mapStateToProps)(SearchPathModal);
